import { Tag } from "antd";

const SegmentedItems = ({ items, color }: {
    items: string[],
    color?: string
}) => {

    const renderStyle = (index: number, lastIndex: number) => {
        const commonStyle = {
            fontSize: 10,
            margin: 0,
            padding: "0px 5px"
        };
        if (index === 0) {
            return {
                ...commonStyle,
                borderRadius: "5px 0px 0px 5px",
                borderRight: 0
            };
        } else if (index === lastIndex) {
            return {
                ...commonStyle,
                borderRadius: "0px 5px 5px 0px"
            };
        } else {
            return {
                ...commonStyle,
                borderRadius: "0px",
                borderRight: "0"
            };
        }
    }

    return (
        <div style={{ whiteSpace: "nowrap", margin: "5px 0" }}>
            {
                items.map((item, index) => (
                    <Tag color={color} style={renderStyle(index, items.length - 1)} key={index}>
                        {item}
                    </Tag>
                ))
            }
        </div>
    )
}

export default SegmentedItems;